import React from 'react';
import SearchComp from 'containers/GlobalSearch/GlobalSearchContainer';
import UpgradeButton from 'containers/Header/UpgradeButtonContainer';
import UserBadge from 'containers/Header/UserBadgeContainer';
import UserMore from 'containers/Header/UserMoreMenuContainer';
import Help from 'containers/Header/Help';
import classes from './Header.module.scss';

interface Props {
  disabled: boolean;
  handleConfirmRemoteModerationEnd: Function;
  isCallConnected: Boolean;
}

const Header = (props: Props) => {
  const handleConfirmRemoteModerationEnd = (evt) => {
    evt.stopPropagation();
    props.handleConfirmRemoteModerationEnd();
  };

  return (
    <div className={classes.container}>
      {!props.isCallConnected ? (
        <>
          <div>
            <UserBadge />
            <UpgradeButton />
          </div>
          <SearchComp />
          <Help />
          <UserMore />
        </>
      ) : null}
      {props.disabled &&
        <div className={classes.cover} onClick={handleConfirmRemoteModerationEnd} />
      }
    </div>
  );
};

export default Header;
